<template>
    <v-app id="order">
        <v-content class="white">
            <div id="custom-wrapper">
                <v-container>
                    <v-row align="center" justify="center" class="pa-5 mb-0 pb-0">
                        <v-col cols="12">
                            <v-card class="pattern-bg pa-5 mx-3 text-dark">
                                Bestelling bevestigen
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-1" v-if="order">
                        <v-col cols="12" class="elevation-cs" style="border-radius:15px;">
                            <v-stepper v-model="e1" class="elevation-0">
                                <v-stepper-header :class="{'mx-8': $vuetify.breakpoint.lgAndUp}" class="elevation-0">
                                    <v-divider></v-divider>
                                    <v-stepper-step step="1" :complete="e1 > 1">Controle</v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="2" :complete="e1 > 2">Betaling</v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="3" :complete="e1 > 3">
                                        Status
                                        bestelling</v-stepper-step>
                                </v-stepper-header>

                                <v-stepper-items>
                                    <v-stepper-content step="1" class="pt-0">
                                        <v-card class="mb-12" color="bg-white-light elevation-0" height="auto">
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                        <v-card>
                                                            <v-card-title style="border-bottom: 1px solid gainsboro;"
                                                                class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                Bestelling
                                                            </v-card-title>
                                                            <v-card class="mx-auto my-3 elevation-0" v-if="order.plan">
                                                                <v-img class="productImage" height="200px" contain
                                                                    :src="order.plan.image">
                                                                </v-img>
                                                                <v-card-title>
                                                                    <h3
                                                                        class="subtitle-1 font-weight-bold text-uppercase">
                                                                        {{order.plan.name}}
                                                                    </h3>
                                                                </v-card-title>
                                                                <v-card-text>
                                                                    <div>
                                                                        <p class="caption">
                                                                            {{order.plan.description}}
                                                                        </p>
                                                                    </div>
                                                                </v-card-text>

                                                            </v-card>
                                                        </v-card>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                        <div>
                                                            <v-card class="subtitle-2 mb-8">
                                                                <v-card-title
                                                                    style="border-bottom: 1px solid gainsboro;"
                                                                    class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Factuur adres
                                                                </v-card-title>
                                                                <v-card-text class="subtitle-2">
                                                                    <div class="mt-3">
                                                                        <ul class="pl-0 text-dark">
                                                                            <li>
                                                                                <v-text-field dense hide-details rounded label="Voornaam" v-model="order.owner.first_name" required outlined>
                                                                                </v-text-field>
                                                                                <v-text-field dense hide-details rounded label="Achternaam" v-model="order.owner.last_name" required outlined>
                                                                                </v-text-field>
                                                                            </li>
                                                                            <v-divider class="my-3"></v-divider>
                                                                            <li>
                                                                                <v-text-field dense hide-details rounded label="Straat" v-model="order.owner.address" required outlined>
                                                                                </v-text-field>
                                                                            </li>
                                                                            <li>
                                                                                <v-text-field dense hide-details rounded label="Plaats" v-model="order.owner.city" required outlined>
                                                                                </v-text-field>
                                                                                <v-text-field dense hide-details rounded label="Postcode" v-model="order.owner.postal_code" required outlined>
                                                                                </v-text-field>
                                                                            </li>
                                                                            <li>

                                                                            </li>
                                                                        </ul>
                                                                        <ul class="pl-0 text-dark">

                                                                            <li>
                                                                                {{order.subscription_details.address}}
                                                                            </li>
                                                                            <li class="font-weight-bold text-uppercase">
                                                                                {{ order.subscription_details.city}}
                                                                            </li>
                                                                            <li>
                                                                                {{order.subscription_details.postal_code}}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                            <v-card class="subtitle-2 mb-8">
                                                                <v-card-title
                                                                        style="border-bottom: 1px solid gainsboro;"
                                                                        class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Bezorg adres
                                                                </v-card-title>
                                                                <v-card-text class="subtitle-2">
                                                                    <div class="mt-3">
                                                                        <ul class="pl-0 text-dark">
                                                                            <li>
                                                                                <v-text-field dense hide-details rounded label="Straat" v-model="order.subscription_details.delivery_address" required outlined>
                                                                                </v-text-field>
                                                                            </li>
                                                                            <li>
                                                                                <v-text-field dense hide-details rounded label="Plaats" v-model="order.subscription_details.delivery_city" required outlined>
                                                                                </v-text-field>
                                                                                <v-text-field dense hide-details rounded label="Postcode" v-model="order.subscription_details.delivery_postal_code" required outlined>
                                                                                </v-text-field>
                                                                            </li>
                                                                            <li>

                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                            <v-card class="subtitle-2">
                                                                <v-card-title
                                                                    style="border-bottom: 1px solid gainsboro;"
                                                                    class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Prijs
                                                                </v-card-title>
                                                                <v-card-text class="subtitle-2" v-if="order.plan">
                                                                    <div class="mt-3">
                                                                        <div class="d-flex justify-content-between">
                                                                            <div>Origineel</div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span>€ {{order.plan.price}}</span>
                                                                        </div>
                                                                        <div class="d-flex justify-content-between">
                                                                            <div>Bezorging</div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span>Gratis</span>
                                                                        </div>
                                                                        <v-divider class="my-2"></v-divider>
                                                                        <div class="d-flex justify-content-between">
                                                                            <div class="font-weight-bold text-dark">
                                                                                Totaalprijs
                                                                            </div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span class="text-dark font-weight-bold">€
                                                                                {{order.plan.price}} p/m</span>
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-btn color="primary" class="float-right"
                                                   @click="placeOrderToggle(order); redirect();">Bevestigen
                                            </v-btn>
                                        </v-card-actions>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </v-content>
    </v-app>
</template>
<script>
    import {
        mapActions,
        mapState
    } from "vuex";

    export default {
        name: 'Order',
        components: {},
        props: {},
        computed: {
            ...mapState({
                order: state => state.order.order,
                banks: state => state.order.banks
            })
        },
        mounted() {
            const secret = this.$route.params.secret;
            this._getOrderConfirm(secret);
            this._getBanks();
        },
        data: () => ({
            e1: 1,
            b_alert: {
                color: '',
                type: '',
                text: '',
            },
            isHidden: true,
            activeTab: 1,
            productTotal: null,
            orderPrice: null,
            totalPrice: null,
            selectedBank: null,
        }),
        methods: {
            ...mapActions("order", ["_getBanks", "_getOrderConfirm", "_makeOrderPayment"]),
            placeOrderToggle(order) {
                order.address += order.address_number + ' ' + order.address_extra;
                const data = {
                    customer: this.order.owner,
                    plan_id: this.order.plan.id,
                    //issuer: this.selectedBank.id,
                    subscription_details: this.order.subscription_details
                };

                this.isHidden = !this.isHidden;
                this._makeOrderPayment(data)
                    .then((url) => {
                        //this.isHidden = !this.isHidden;
                        console.log(url);
                        //this.$router.push({name: 'status'});
                        window.location.replace(url);
                    })
                    .catch(() => {
                        alert("Something went wrong");
                    });
            },
            redirect() {
                this.e1 = 4;
                this.b_alert.text = 'U wordt herleid naar de betaalpagina...';
                this.b_alert.color = 'blue';
                this.b_alert.type = 'info';
            },
        }
    }
</script>

<style src="./Order.scss" lang="scss"></style>
